import { useContactConsent } from "@/hooks/consent";
import type { ConsentSubjectType } from "@/services/consent";

import { ConsentChip } from "./ConsentChip";

interface ContactConsentChipProps {
  subjectType: ConsentSubjectType;
  subjectId: string;
}

export function ContactConsentChip({ subjectType, subjectId }: ContactConsentChipProps) {
  const { data, isLoading } = useContactConsent(subjectType, subjectId);

  if (!subjectId) return null;

  return <ConsentChip consent={data} isLoading={isLoading} />;
}
